import React, { Component } from 'react';
import { FindID } from './FindID';
import { FindPwd } from './FindPwd';
import { SignIn } from './SignIn';
import { HeaderSub } from '../../Common/HeaderSub'

/* 개발담당:양유빈
 * 화면기능:로그인 화면 컨테이너
 * 세부설명:로그인, 아이디 찾기, 비밀번호 찾기 컴포넌트가 구성됨
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.SignIn,  //기본 컴포넌트 할당
            Uid: null
        };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "FindID": "FindID",
        "FindPwd": "FindPwd",
        "SignIn": "SignIn"
    }
    //초기화
    componentDidMount() {
    }
    renderPick(Uid) {
        if (this.state.RenderName === this.CompName.FindID) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="아이디찾기"
                        ComponentUrl="SignIn"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                        
                    />
                    <FindID
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.FindPwd) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="비밀번호찾기"
                        ComponentUrl="SignIn"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <FindPwd
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else {
            return (
                <SignIn
                    RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                />
            );
        }
    }

    render() {
        let Uid = this.state.Uid;
        let RnderAct = this.renderPick(Uid);
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
